/**
 * Copyright 2018 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */
import URI from "urijs";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LogOutCallback = ({ doLogout }) => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const storedState = window?.localStorage?.getItem("post_logout_state");
  const query = URI.parseQuery(location.search);

  useEffect(() => {
    window.localStorage.removeItem("post_logout_state");

    if (!query?.state) {
      setError(t("errors.missing_state"));
    } else if (query.state !== storedState) {
      setError(t("errors.invalid_state"));
    }

    doLogout();
    navigate("/");
  }, []);

  if (error) {
    return <p>{error}</p>;
  }

  return null;
};

export default LogOutCallback;
